/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 */


import { Injectable } from '@angular/core';
import { IValidator } from 'src/app/_common/component/IValidator';
import { Progress } from 'src/app/_common/constant/page-const';
import { InputData } from 'src/app/_common/data/input-data';
import { Confirm } from './constant';

@Injectable({
  providedIn: 'root',
})

export class ProgressService {

       public static validator:IValidator;

       public isOpened:boolean = false;

       public progressIndex:Object  = new Object();  // number-number
       public progressNameMap:Map<number,string> = new Map();

       public progressStatus:Object = new Object();  // number-number
       public progressMenuMap:Array<ProgressData> = new Array(11);

       public currentLabel:string;
       public currentIndex:number;

       public CCBData:ProgressData;
       public SINData:ProgressData;
       public BCData:ProgressData;

       public nextChild(idx:number) {  
             
              this.init(idx);

              for ( let i = 1; i < idx; i++ )
                    this.progressStatus[i] = 8;
                     
       }

       public init(idx:number) {  // 1

              this.progressStatus[idx] = 1;        // Start state
              for ( let i = idx+1; i < this.progressMenuMap.length; i++ )    // index 0 is not used.
                    this.progressStatus[i] = 0;

              this.setIndex(idx);
       }

       public restore(data:InputData) { 

            for ( let i = 1; i < Progress.OrderBC; i++ )    // index 0 is not used.
                  this.progressStatus[i] = 2;

            if ( data.orderOfBC.total > 0 ) this.progressStatus[Progress.OrderBC] = 2;
            else                            this.progressStatus[Progress.OrderBC] = 4;

            if ( data.CCB.chk_consent  ) this.progressStatus[Progress.CCB] = 2;
            else                         this.progressStatus[Progress.CCB] = 4;

            if ( data.SIN.chk_read  ) this.progressStatus[Progress.SIN] = 2;
            else                      this.progressStatus[Progress.SIN] = 4;

            if ( data.CESP.chk_consent  ) this.progressStatus[Progress.ESR] = 2;
            else                          this.progressStatus[Progress.ESR] = 4;

            this.setIndex(Progress.Summary);
      }

      public greyedOut(isNext?:boolean){
             
              let menuID:number =  ProgressService.validator.IdOfChanged(); 

              if ( menuID > 0 ) {
                   for ( let i = menuID+1; i < this.progressMenuMap.length; i++ )    { // index 0 is not used. 
                         if ( this.progressStatus[i] > 0 ) this.progressStatus[i] = 0;
                   }

                   this.progressStatus[menuID] = 1;
                   return true;
              }
              return false;
       }

       public adjustBundles(data:InputData) {

            let receiptLabel:ProgressData = this.progressMenuMap[Progress.Receipt];

            if ( data.eligibility.isCustodyOtherThanParent == Confirm.YES ) {      

                  
                  this.progressStatus[Progress.SIN] = -1;
                  this.progressStatus[Progress.ESR] = -1;
                  this.progressStatus[Progress.Receipt] = -1;

                  data.CCB.clear();
                  data.SIN.clear();
                  data.clearSINParent();
                  data.CESP.clear();
      
                  if ( data.aboutChild.isChildDeceased == Confirm.YES )  {
                       this.progressStatus[Progress.CCB] = -1;
                       this.progressStatus[Progress.OrderBC] = 0;
                       this.progressMenuMap[Progress.OrderBC]=receiptLabel;
                       data.orderOfBC.clear();
                  }
                  else {
                        if ( this.progressStatus[Progress.OrderBC] == -1 )  
                             this.progressStatus[Progress.OrderBC] = 0;

                        this.progressMenuMap[Progress.OrderBC] = this.BCData;     
                        this.progressStatus[Progress.CCB] = 0;
                        this.progressMenuMap[Progress.CCB] = receiptLabel;
                  }
            }
            else {
                 if ( this.progressStatus[Progress.OrderBC] == -1 ) 
                      this.progressStatus[Progress.OrderBC] = 0;

                 if ( this.progressStatus[Progress.CCB] == -1 ) 
                      this.progressStatus[Progress.CCB] = 0;

                 this.progressMenuMap[Progress.OrderBC] = this.BCData;    
                 this.progressMenuMap[Progress.CCB] = this.CCBData; 

                 if ( data.aboutChild.isChildDeceased == Confirm.YES ) {

                        data.SIN.clear();
                        data.clearSINParent();
                        data.CESP.clear();
                        this.progressStatus[Progress.SIN] = 0;
                        this.progressStatus[Progress.ESR] = -1;
                        this.progressStatus[Progress.Receipt] = -1;
                        this.progressMenuMap[Progress.SIN] = receiptLabel;     
                  }
                  else {
                        if ( this.progressStatus[Progress.SIN] == -1 ) 
                             this.progressStatus[Progress.SIN] = 0;

                        if ( this.progressStatus[Progress.ESR] == -1 ) 
                             this.progressStatus[Progress.ESR] = 0;

                        this.progressStatus[Progress.Receipt] = 0;

                        this.progressMenuMap[Progress.SIN] = this.SINData;     
                  }
            }
       }

       public setMenu(idx:number) {

            if ( this.progressStatus[idx] == 0 ) this.progressStatus[idx] = 1;
            
            if ( idx > 0 ) {
                if ( this.progressStatus[idx-1] == 1 ) this.progressStatus[idx-1] = 2;
            }
       }

       public setIndex(idx:number) {
              this.currentIndex = this.progressIndex[idx];
              this.currentLabel = this.progressNameMap.get(idx);
       }
}

export class ProgressData {
      public name:string;
      public alt:string;
      constructor(name:string,alt:string){
            this.name = name;
            this.alt = alt;
      }
}


